import {
  type MessageSequenceStatus,
  type MessageSort,
  WelcomeMessageScope,
} from '@api'

import type { WelcomeMessage } from '@/modules/creator-settings/types.ts'
import { apiClientV3 } from '@/utils/axios'

function getListMessages(
  creatorId: number,
  scope: WelcomeMessageScope,
  sortOption: MessageSort,
) {
  return apiClientV3
    .get<WelcomeMessage[]>(`/settings/welcome-messages/${creatorId}/${scope}`, {
      params: {
        sortBy: sortOption,
      },
    })
    .then((response) => {
      return response.data
    })
}

function getMessageById(
  creatorId: number,
  scope: WelcomeMessageScope,
  messageId: string,
) {
  return apiClientV3
    .get<WelcomeMessage>(
      `/settings/welcome-messages/${creatorId}/${scope}/${messageId}`,
    )
    .then((response) => {
      return response.data
    })
}

function deleteMessage(
  creatorId: number,
  scope: WelcomeMessageScope,
  messageId: number,
) {
  return apiClientV3.delete(
    `/settings/welcome-messages/${creatorId}/${scope}/${messageId}`,
  )
}

export function updateWelcomeMessageToggle(
  creatorId: number,
  messageId: string,
  scope: WelcomeMessageScope,
  value: MessageSequenceStatus,
) {
  return apiClientV3.put(
    `/settings/welcome-messages/${creatorId}/${scope}/${messageId}/toggle-message`,
    value,
  )
}

export const welcomeMessageService = {
  getListMessages,
  getMessageById,
  deleteMessage,
  updateWelcomeMessageToggle,
}
